 

import { WebSocketConnect, WebSocketConnectClass } from "@/socket";
import {
  setOnlineTeammates,
  removeOfflineTeammates,
  SET_TEAMMATE,
} from "@/store/projectData/projectDataActions";
import { fetchProjectsOnUpdate } from "@/store/project/projectActions";
// import { processChannelTopicUpdate } from './projectProfileActions';
import {
  SET_TEAMMATE_ON_TOPIC,
  REMOVE_TEAMMATE_ON_TOPIC,
  SET_PROJECT_CHANNEL,
} from "./projectProfileConstants";

export function initializeRebelProjectChannel(projectId) {
  return (dispatch, getState) => {
    const { user } = getState();
    const channelName = WebSocketConnectClass.makeChannelName(
      WebSocketConnectClass.REBEL_PROJECT_ROOM_LOBBY,
      projectId
    );
    const channel = WebSocketConnect.channel(user.get("jwt"), channelName);

    channel
      .join()
      .receive("ok", () =>
        dispatch({ type: SET_PROJECT_CHANNEL, projectId, channel })
      )
      .receive("error", (error) => {
        console.warn("error", error);
      });

    channel.on("presence_state", (state) => {
      dispatch(setOnlineTeammates(state));
    });

    // Event sent from server that tells us there is diff of users in channel
    channel.on("presence_diff", (payload) => {
      if (payload.joins) {
        dispatch(setOnlineTeammates(payload.joins));
      }

      if (payload.leaves) {
        dispatch(removeOfflineTeammates(payload.leaves));
      }
    });

    // update project data
    channel.on("project_profile_updated", () => {
      dispatch(fetchProjectsOnUpdate());
    });

    // if a user is on a challenge topic
    channel.on("joined_project_topic", (payload) => {
      // if userid is not current users, add to user list
      dispatch({
        type: SET_TEAMMATE_ON_TOPIC,
        topicId: Number(payload.topicId),
        isEditing: payload.isEditing,
        userId: payload.userId,
      });
    });

    // if a user is on a challenge topic
    channel.on("editing_project_topic", (payload) => {
      // if userid is not current users, add to user list
      dispatch({
        type: SET_TEAMMATE_ON_TOPIC,
        topicId: Number(payload.topicId),
        isEditing: payload.isEditing,
        userId: payload.userId,
      });
    });

    // if a user leaves a topic
    channel.on("left_project_topic", (payload) => {
      dispatch({
        type: REMOVE_TEAMMATE_ON_TOPIC,
        userId: payload.userId,
        topicId: Number(payload.topicId),
      });
      // if userid is not current users, add to user list
      // if (payload.userId !== user.get('id')) {
      //   dispatch(removeTeammateOnTopic(payload.topicId, payload.userId));
      // }
    });

    // // when a topic is saved
    // channel.on('topic_updated', (payload) => {
    //   dispatch(processChannelTopicUpdate(payload));
    // });

    // when a user in the project has been updated
    channel.on("user_project_role_updated", (payload) => {
      dispatch({ type: SET_TEAMMATE, data: payload.data });
    });
  };
}

export function broadcastJoinProjectChallengeTopic(projectId, topicId) {
  return (dispatch, getState) => {
    const channel = getState().projectProfilev1.projectChannels.get(
      parseInt(projectId, 10)
    );

    if (channel) {
      channel.push(`join:project_topic:${topicId}`, { topicId });
    }
  };
}

export function broadcastEditProjectChallengeTopic(projectId, topicId) {
  return (dispatch, getState) => {
    const channel = getState().projectProfilev1.projectChannels.get(
      parseInt(projectId, 10)
    );
    if (channel) {
      channel.push(`edit:project_topic:${topicId}`, { topicId });
    }
  };
}

export function broadcastLeaveProjectChallengeTopic(projectId, topicId) {
  return (dispatch, getState) => {
    const channel = getState().projectProfilev1.projectChannels.get(
      parseInt(projectId, 10)
    );
    if (channel) {
      channel.push(`leave:project_topic:${topicId}`, { topicId });
    }
  };
}
//
